import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import CategoryLink from 'components/atoms/CategoryLink';
import { useElement } from 'util/event';

import styles from './index.css';

const SubCategory = ({ defaultWidth = 120, onUpdateWidth, category }) => {
	const { refChild, width } = useElement({ defaultWidth, onUpdateWidth });

	return (
		<div className={styles.wrapSubCategory} style={{ left: `calc(50% - (${width} * 0.5px))` }}>
			<div className={styles.subCategory} ref={refChild}>
				{category.children.map(item => (
					<div key={item.id}>
						<CategoryLink item={item}>{item.name}</CategoryLink>
						{item.children.length > 0 && (
							<div className={styles.wrapSubSubCategory}>
								<div className={styles.subSubCategory}>
									{item.children.map(subItem => (
										<CategoryLink key={subItem.id} item={subItem}>
											{subItem.name}
										</CategoryLink>
									))}
								</div>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};
const Navigation = ({ className, categoryList = [] }) => (
	<nav className={classnames(styles.navigation, className)}>
		<ul>
			{categoryList.map(category => (
				<li key={category.id}>
					{category.disableLink ? (
						<div className={styles.name}>{category.name}</div>
					) : (
						<Link className={styles.name} to={`/product?category_id=${category.id}`}>
							{category.name}
						</Link>
					)}
					<SubCategory category={category} />
				</li>
			))}
		</ul>
	</nav>
);

export default Navigation;
